import {ACTIONTYPES} from "../Actions/Types";
import { removeLoginCookies } from "../../Utils/Helper";

const initialState = {
    accessToken: "",
    accessLevels: ""
}

export const AuthReducer = (state = initialState, { type, payload }) => {
    switch(type) {
        case ACTIONTYPES.LOGIN_USER:
            return {...state};
        case ACTIONTYPES.SET_LOGIN_USER:
            return {
                ...state,
                accessLevels: payload.accessLevels,
                accessToken: payload.accessToken
            }
        case ACTIONTYPES.LOGOUT_USER:
            removeLoginCookies();
            return {...state,
                accessLevels: "",
                accessToken: ""};
        default:
            return state;
    }
}